import styled from 'styled-components';

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.color.background};
`;

const Spinner = styled.div`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${p => p.theme.color.backgroundRush};

  svg {
    fill: ${p => p.theme.color.turquoise};
  }
`;

export const Styled = {
  Container,
  Spinner,
};
